import {Tooltip} from 'platform/components';
import {HStack, Text, VStack} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import {defaultTo} from 'ramda';

import {useGetTenantQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {DEFAULT_CURRENCY} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

type Price = {
  withoutVat?: {
    amount?: number | null;
    currency?: string | null;
  } | null;
  vat?: {
    amount?: number | null;
    currency?: string | null;
  } | null;
  withVat?: {
    amount?: number | null;
    currency?: string | null;
  } | null;
};

interface PriceDetailTooltipProps extends RequiredTestIdProps {
  materialPrice?: Price | null;
  labourPrice?: Price | null;
  smallUnitMaterialPrice?: Price | null;
  children: React.ReactNode;
}

export function PriceDetailTooltip(props: PriceDetailTooltipProps) {
  const {data: {currency: defaultCurrency} = {}} = useGetTenantQuery();
  const formatCurrency = useFormatCurrency();

  return (
    <Tooltip
      label={
        <VStack>
          <HStack spacing={1}>
            <Text size="xSmall" alternative color="white">
              {i18n.t('entity.order.priceDetail.labourPrice')}:
            </Text>
            <Text size="xSmall" alternative color="white">
              {formatCurrency(
                defaultTo(0, props.labourPrice?.withVat?.amount),
                defaultTo(defaultCurrency ?? DEFAULT_CURRENCY, props.labourPrice?.withVat?.currency)
              )}
            </Text>
          </HStack>
          <HStack spacing={1}>
            <Text size="xSmall" alternative color="white">
              {i18n.t('entity.order.priceDetail.materialPrice')}:
            </Text>
            <Text size="xSmall" alternative color="white">
              {formatCurrency(
                defaultTo(0, props.materialPrice?.withVat?.amount),
                defaultTo(
                  defaultCurrency ?? DEFAULT_CURRENCY,
                  props.materialPrice?.withVat?.currency
                )
              )}
            </Text>
          </HStack>
          <HStack spacing={1}>
            <Text size="xSmall" alternative color="white">
              {i18n.t('entity.order.priceDetail.smallUnitMaterialPrice')}:
            </Text>
            <Text size="xSmall" alternative color="white">
              {formatCurrency(
                defaultTo(0, props.smallUnitMaterialPrice?.withVat?.amount),
                defaultTo(
                  defaultCurrency ?? DEFAULT_CURRENCY,
                  props.smallUnitMaterialPrice?.withVat?.currency
                )
              )}
            </Text>
          </HStack>
        </VStack>
      }
      data-testid={suffixTestId('priceDetail', props)}
    >
      {props.children}
    </Tooltip>
  );
}
